import React, { memo, useEffect } from 'react';
import type { FC } from 'react';
import cn from 'classnames';
import { CheckmarkOnCircleMIcon } from '@alfalab/icons-glyph/CheckmarkOnCircleMIcon';
import { sendEvent } from '@alfa-bank/site-helpers-common/browser/send-event';

import { deliveryStepAnalytics as analytics } from '../../../../analytics';

import type { TOfficesDelivery } from './models';
import styles from './styles/styles.css';

export const OfficeDelivery: FC<TOfficesDelivery> = memo(
    ({ OfficeSelection, Plate, Text, officeDeliveryType, offices, selectedOffice }) => {
        useEffect(() => {
            if (offices && officeDeliveryType === 'any') {
                sendEvent(analytics.officeDelivery.anyOffice);
            }

            if (offices && officeDeliveryType === 'specific') {
                sendEvent(analytics.officeDelivery.view);
            }
            // eslint-disable-next-line react-hooks/exhaustive-deps
        }, [officeDeliveryType]);

        if (!offices) {
            return null;
        }

        if (officeDeliveryType === 'any') {
            return (
                <Plate
                    border={false}
                    className={cn(styles.external, styles.plate)}
                    leftAddons={<CheckmarkOnCircleMIcon />}
                    rounded={false}
                    styler={{ borderRadius: 12 }}
                    title="Карту сможете забрать уже сегодня в любом офисе Альфа-Банка"
                    titleView="bold"
                    view="common"
                >
                    <Text styler={{ margin: 0, padding: 0 }} view="primary-small">
                        Как только закажете доставку
                    </Text>
                </Plate>
            );
        }

        return <OfficeSelection offices={offices} selectedOffice={selectedOffice} />;
    }
);
